import { createSlice } from "@reduxjs/toolkit";
import { getCustomerList } from "../utilsReduxApi/getCustomerList";
import { getCollectionList } from "../utilsReduxApi/getCollectionList";
import { getProductList } from "../utilsReduxApi/getProductList";
import { getTages } from "../utilsReduxApi/getTages";
// import { getBrands } from "../utilsReduxApi/getBrand";

const UtilsSlice = createSlice({
  name: "utils",
  initialState: {
    customerList: [],
    categoryList: [],
    productList: [],
    tageList: [],
    getCategory: [],
    getProduct: [],
    getBrand: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerList.fulfilled, (state, action) => {
      state.customerList = action.payload.data.customer;
    });
    builder.addCase(getCollectionList.fulfilled, (state, action) => {
      state.categoryList = action.payload.data.response;
    });
    builder.addCase(getProductList.fulfilled, (state, action) => {
      // console.log("action.payload", action.payload);
      state.productList = action.payload.data.response;
      // console.log(state.clientList);
    });
    builder.addCase(getTages.fulfilled, (state, action) => {
      state.tageList = action.payload.data.response;
    });
    // builder.addCase(getBrands.fulfilled, (state, action) => {
    //   state.getBrand = action.payload.data.brand;
    // });
  },
});

export default UtilsSlice.reducer;
